export default {
  title: "Ear.Contact",
  images: [
    {
      url: "/images/logo-sign.svg"
    }
  ]
};
